import { tns } from "tiny-slider";

const sliders = Array.from(document.querySelectorAll(".timeline-wrapper"));

function setup(el) {
    const container = el.querySelector('.timeline-content')
    const controlsContainer = el.querySelector('.timeline-controls')

    const slider = tns({
        container,
        controlsContainer,
        nav: false,
        items: 1,
        gutter: 88,
        autoHeight: false,
        responsive: {
            1200: {
                items: 2,
            },
        }
    })

    const nexts = Array.from(el.querySelectorAll('.timeline-mobile-controls .prev'))
    const prevs = Array.from(el.querySelectorAll('.timeline-mobile-controls .next'))

    nexts.forEach(next => {
        next.addEventListener('click', () => {
            slider.goTo('next')
        })
    })

    prevs.forEach(prev => {
        prev.addEventListener('click', () => {
            slider.goTo('prev')
        })
    })
}

function init() {
    if (!sliders) return;

    sliders.forEach(setup)
}

init();
